export default __webpack_public_path__ + "static/media/trivia-night.956c6520.png";